var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function stripTrailingSlash(value) {
  return value.replace(/^(.+?)\/*?$/, "$1");
}
__name(stripTrailingSlash, "stripTrailingSlash");
export {
  stripTrailingSlash
};
